import { StatusObjType } from "./workStatus";
import { customFunctions } from "@/config/customFunction";

export const externalUserTypeColor = {
  SALES: "blue.7",
  PURCHASE: "green.7",
  BI_DIRECTION: "yellow.7",
  OUTSOURCING: "pink.7",
};

export const externalUserType: StatusObjType = {
  SALES: customFunctions.ADD_PARTNER_TYPE_CUSTOM ? "partner.SALES_M" : "user.SALES",
  PURCHASE: customFunctions.ADD_PARTNER_TYPE_CUSTOM ? "partner.PURCHASE_M" : "user.PURCHASE",
  BI_DIRECTION: customFunctions.ADD_PARTNER_TYPE_CUSTOM ? "partner.BI_DIRECTION_M" : "user.BI_DIRECTION",
  OUTSOURCING: "user.OUTSOURCING",
};

export const setExternalUserType = (status: string | undefined) => {
  return externalUserType[status ?? ""];
};
